



















































































import PieChartCard from "@/components/analytics/PieChartCard.vue";
import MyDamageDetailSideCard from "@/components/report/user/MyDamageDetailSideCard.vue";
import Notifications from "@/components/thg/Notifications.vue";
import TableWrapper from "@/components/utility/TableWrapper.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { AnalyticsFleetModule } from "@/store/modules/fleet/analytics-fleet.store";
import { ManagerFleetModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import { DocumentDirectionEnum } from "@/models/invoice.entity";
import { MrfiktivBaseChartItemViewmodelGen } from "@/services/mrfiktiv/v1/data-contracts";
import BarChartCard from "@/components/analytics/BarChartCard.vue";

@Component({
  components: {
    LayoutReportWithBanner,
    Notifications,
    TableWrapper,
    MyDamageDetailSideCard,
    PieChartCard,
    BarChartCard
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetAnalyticsView extends Vue {
  DocumentDirectionEnum = DocumentDirectionEnum;

  isLoading = false;
  selectedId: string | null = null;

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetHomeView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: this.$t("common.nouns.analytics"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetAnalyticsView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetIds() {
    return UserModule.fleetPermission?.map(p => p.fleetId);
  }

  get fleetId() {
    return ManagerFleetModule.current?.id;
  }

  get damageTypeSubtotalData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.damageTypeSubtotalOutboundData
      .filter(d => d.direction === DocumentDirectionEnum.OUTBOUND)
      .map(c => ({
        name: this.$t(`enums.DamageTypeEnum.${c.name}`).toString(),
        value: c.value ?? undefined
      }));
  }

  get coverageTypeSubtotalData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.coverageTypeSubtotalOutboundData
      .filter(d => d.direction === DocumentDirectionEnum.OUTBOUND)
      .map(c => ({
        name: this.$t(`enums.CoverageTypeEnum.${c.name}`).toString(),
        value: c.value ?? undefined
      }));
  }

  get damageTypeCountData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.damageTypeData.map(c => ({
      name: this.$t(`enums.DamageTypeEnum.${c.name}`).toString(),
      value: c.value ?? undefined
    }));
  }

  get coverageTypeCountData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.coverageTypeData.map(c => ({
      name: this.$t(`enums.CoverageTypeEnum.${c.name}`).toString(),
      value: c.value ?? undefined
    }));
  }

  get tripTypeCountData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.tripTypeData.map(c => ({
      name: this.$t(`enums.TripTypeEnum.${c.name}`).toString(),
      value: c.value ?? undefined
    }));
  }

  get statusDistributionData() {
    return AnalyticsFleetModule.statusDistributionData.map(c => ({
      name: this.$t(`partner.common.reportProgressStatus.${c.name}`).toString(),
      value: c.value
    }));
  }

  get weekdayDistributionData() {
    return AnalyticsFleetModule.weekdayDistributionData;
  }

  get topCreditorData() {
    return AnalyticsFleetModule.topCreditorData;
  }

  get i18n() {
    return this.$t("views.report.fleet.FleetVehicleView");
  }

  async mounted() {
    await this.load();
  }

  async load() {
    if (!this.fleetId) {
      return;
    }

    this.isLoading = true;

    try {
      const promises: Promise<any>[] = [];
      promises.push(
        AnalyticsFleetModule.getDamageTypeSubtotalData({ partnerId: this.partnerId, fleetId: this.fleetId })
      );
      promises.push(
        AnalyticsFleetModule.getCoverageTypeSubtotalData({ partnerId: this.partnerId, fleetId: this.fleetId })
      );
      promises.push(AnalyticsFleetModule.getTripTypeData({ partnerId: this.partnerId, fleetId: this.fleetId }));
      promises.push(AnalyticsFleetModule.getDamageTypeData({ partnerId: this.partnerId, fleetId: this.fleetId }));
      promises.push(AnalyticsFleetModule.getCoverageTypeData({ partnerId: this.partnerId, fleetId: this.fleetId }));
      promises.push(AnalyticsFleetModule.getStatusDistribution({ partnerId: this.partnerId, fleetId: this.fleetId }));
      promises.push(AnalyticsFleetModule.getWeekdayAnalysis({ partnerId: this.partnerId, fleetId: this.fleetId }));
      promises.push(AnalyticsFleetModule.getTopCreditorData({ partnerId: this.partnerId, fleetId: this.fleetId }));

      await Promise.all(promises);
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }
}
